import { getChromeAlarms } from './chrome/wrappers';
import {
  CURRENT_SAFE_NETWORK_UPDATE_ALARM_NAME,
  onUpdateActiveSafeNetworkRetry,
} from './safeNetworks/safeNetworksProbe';
import {
  PAUSE_INTERNET_EXPIRES_ALARM_NAME,
  onPauseInternetExpired,
  ROUTINE_ACTIVE_ALARM,
  ROUTINE_EXPECTED_SOON_ALARM,
  onRoutineExpired,
  syncRoutineExpiryAlarmFromStore,
  DAILY_QUOTA_DAY_CHANGE_ALARM,
  onDayChange,
} from './actions/rulesActions';
import { formatAlarmTimestamp } from './alarmUtils';
import { nowImmediate } from './lib/dateTime';
export { createAlarmWithDelay, clearAlarm } from './alarmUtils';

const logAlarmExecution = (alarm: chrome.alarms.Alarm): void => {
  const scheduledTime =
    alarm.scheduledTime != null
      ? formatAlarmTimestamp(alarm.scheduledTime)
      : 'unknown';
  console.log(
    `[Alarms] Executing "${alarm.name}" at ${formatAlarmTimestamp(
      nowImmediate()
    )} (scheduledTime=${scheduledTime})`
  );
};

/**
 * Setup the callbacks for the scheduled alarms.
 *
 * This should be called as soon as possible to prevent race conditions.
 */
export const setupAlarmsCallbacks = (
  initializeData: () => Promise<void>,
  syncRules: () => Promise<void>
) => {
  getChromeAlarms().onAlarm.addListener(async alarm => {
    // Safe Networks state retries
    if (alarm.name === CURRENT_SAFE_NETWORK_UPDATE_ALARM_NAME) {
      logAlarmExecution(alarm);
      await initializeData();
      await onUpdateActiveSafeNetworkRetry();
    }

    // Pause Internet expiry: refresh tabs so any tab still pinned to the
    // pause blocker can re-evaluate its verdict and unblock if appropriate.
    // We re-run `initializeData` because the alarm may fire on a cold
    // service worker boot.
    if (alarm.name === PAUSE_INTERNET_EXPIRES_ALARM_NAME) {
      logAlarmExecution(alarm);
      await initializeData();
      await onPauseInternetExpired();
    }

    if (alarm.name === ROUTINE_ACTIVE_ALARM) {
      logAlarmExecution(alarm);
      await initializeData();
      await syncRules();
      await onRoutineExpired();
    }

    if (alarm.name === ROUTINE_EXPECTED_SOON_ALARM) {
      logAlarmExecution(alarm);
      await initializeData();
      await syncRoutineExpiryAlarmFromStore();
    }

    // Day change: refresh tabs so any tab still pinned to the daily-limit
    // blocker re-evaluates its verdict once the new day's quota applies.
    // We re-run `initializeData` because the alarm may fire on a cold
    // service worker boot.
    if (alarm.name === DAILY_QUOTA_DAY_CHANGE_ALARM) {
      logAlarmExecution(alarm);
      await initializeData();
      await onDayChange();
    }
  });
};
